// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__11abL","loaderOuter":"PageOverlayLoader_loaderOuter__3uR9H"};